import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, CheckCircle2, MessageCircle, Mail } from "lucide-react";
import { THANKYOU } from "@/constants/testIds";

export default function ThankYou() {
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("lead_name");
      if (stored) setFirstName(stored);
    } catch (_) { /* ignore */ }
  }, []);

  return (
    <main
      data-testid={THANKYOU.page}
      className="relative min-h-screen overflow-hidden bg-cream flex flex-col"
    >
      <span className="blob bg-coral-soft" style={{ width: 320, height: 320, top: -120, right: -120 }} />
      <span className="blob bg-coral-soft" style={{ width: 280, height: 280, bottom: -100, left: -100 }} />

      <header className="relative z-10 border-b border-[var(--brand-line)]/60">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="brand-mark" data-testid={THANKYOU.backHome}>
            <Heart className="heart" fill="currentColor" strokeWidth={0} size={20} />
            <span className="font-serif-brand text-[1.35rem] md:text-[1.5rem] font-semibold text-ink">
              Casal por São Paulo
            </span>
          </Link>
          <span className="hidden sm:inline-flex text-[11px] uppercase tracking-[0.18em] text-ink-soft font-sans-brand">
            Confirmação de inscrição
          </span>
        </div>
      </header>

      <section className="relative z-10 flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-2xl w-full text-center">
          <div className="fade-in-up inline-flex items-center justify-center w-16 h-16 rounded-full bg-coral-soft text-coral mb-6">
            <CheckCircle2 size={32} strokeWidth={2.2} />
          </div>

          <h1
            data-testid={THANKYOU.heading}
            className="fade-in-up delay-1 font-serif-brand text-[2.1rem] md:text-[3rem] font-semibold leading-tight text-ink mb-5"
          >
            {firstName ? `Obrigado, ${firstName}!` : "Obrigado!"}
            <span className="block text-coral italic mt-1">
              Sua inscrição foi confirmada.
            </span>
          </h1>

          <hr className="thin-rule fade-in-up delay-2" />

          <p className="fade-in-up delay-2 font-sans-brand text-[16px] md:text-[17px] leading-relaxed text-ink-soft max-w-xl mx-auto mb-8">
            Em instantes você receberá o material completo da viagem à China.
            Fique de olho no seu <span className="text-ink font-medium">e-mail</span> e no
            <span className="text-ink font-medium"> WhatsApp</span> — geralmente chega em até alguns minutos.
          </p>

          <div className="fade-in-up delay-3 grid sm:grid-cols-2 gap-3 max-w-md mx-auto mb-10">
            <div className="bg-white/80 backdrop-blur border border-[var(--brand-line)] rounded-xl px-4 py-4 flex items-center gap-3 text-left">
              <Mail size={20} className="text-coral" />
              <div>
                <p className="text-[11px] uppercase tracking-wider text-ink-soft font-sans-brand">Passo 1</p>
                <p className="text-sm font-medium text-ink font-sans-brand">Confira seu e-mail</p>
              </div>
            </div>
            <div className="bg-white/80 backdrop-blur border border-[var(--brand-line)] rounded-xl px-4 py-4 flex items-center gap-3 text-left">
              <MessageCircle size={20} className="text-coral" />
              <div>
                <p className="text-[11px] uppercase tracking-wider text-ink-soft font-sans-brand">Passo 2</p>
                <p className="text-sm font-medium text-ink font-sans-brand">Acompanhe o WhatsApp</p>
              </div>
            </div>
          </div>

          <Link to="/" className="cta-pill fade-in-up delay-4 font-sans-brand">
            Voltar para a página inicial
          </Link>
        </div>
      </section>

      <footer className="relative z-10 border-t border-[var(--brand-line)]/70 bg-[var(--brand-cream-2)]/60">
        <div className="max-w-6xl mx-auto px-6 py-6 text-center">
          <p className="text-xs text-ink-soft font-sans-brand">
            © {new Date().getFullYear()} Casal por São Paulo. Experiências que criam histórias.
          </p>
        </div>
      </footer>
    </main>
  );
}
